import layoutHeaderAside from '@/layout/header-aside'

// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
const _import = require('@/libs/util.import.' + process.env.NODE_ENV)

export default {
  path: '/spread',
  name: 'spread',
  meta: {
    auth: true
  },
  redirect: {
    name: 'spread/analysis_wechat'
  },
  component: layoutHeaderAside,
  children: (pre => [
    {
      path: 'bigscreen',
      name: `${pre}bigscreen`,
      component: _import('spread/bigscreen'),
      meta: {
        title: '大屏管理'
      }
    },
    // {
    //   path: `index`,
    //   name: `spread-index`,
    //   component: _import('rmplus/analysis/wechat'),
    //   meta: {
    //     title: '微信数据分析'
    //   }
    // },
    {
      path: 'analysis_wechat',
      name: `${pre}analysis_wechat`,
      // component: _import('rmplus/analysis/wechat'),
      component: _import('rmplus/analysis/wechat1'),
      meta: {
        title: '微信数据分析'
      }
    },
    {
      path: 'analysis_weibo',
      name: `${pre}analysis_weibo`,
      // component: _import('rmplus/analysis/weibo'),
      component: _import('rmplus/analysis/weibo1'),
      meta: {
        title: '微博数据分析'
      }
    },
    {
      path: 'analysis_toutiao',
      name: `${pre}analysis_toutiao`,
      // component: _import('rmplus/analysis/toutiao'),
      component: _import('rmplus/analysis/toutiao1'),
      meta: {
        title: '头条数据分析'
      }
    },
    {
      path: 'hot_wechat',
      name: `${pre}hot_wechat`,
      // component: _import('spread/hot/wechat'),
      component: _import('spread/hot/wechat1'),
      meta: {
        title: '微信数据分析'
      }
    },
    {
      path: 'hot_weibo',
      name: `${pre}hot_weibo`,
      // component: _import('spread/hot/weibo'),
      component: _import('spread/hot/weibo1'),
      meta: {
        title: '微博数据分析'
      }
    },
    {
      path: 'hot_toutiao',
      name: `${pre}hot_toutiao`,
      // component: _import('spread/hot/toutiao'),
      component: _import('spread/hot/toutiao1'),
      meta: {
        title: '头条数据分析'
      }
    },
    {
      path: 'kpi',
      name: `${pre}kpi`,
      component: _import('spread/kpi1'),
      meta: {
        title: '部门绩效'
      }
    },

    {
      path: 'effect',
      name: `${pre}effect`,
      component: _import('spread/effect'),
      meta: {
        title: '传播效果统计分析'
      }
    },
    {
      path: 'hotAnalysis',
      name: `${pre}hotAnalysis`,
      component: _import('spread/hotAnalysis'),
      meta: {
        title: '热文分析'
      }
    },
    {
      path: 'aloneAnalysis',
      name: `${pre}aloneAnalysis`,
      component: _import('spread/aloneAnalysis'),
      meta: {
        title: '热文分析'
      }
    },
    {
      path: 'preState',
      name: `${pre}preState`,
      component: _import('spread/preState'),
      meta: {
        title: '发布状况'
      }
    },
    {
      path: 'totalAnalysis',
      name: `${pre}totalAnalysis`,
      component: _import('spread/totalAnalysis'),
      meta: {
        title: '分析汇总'
      }
    },
    {
      path: 'accountAnalysis_wx',
      name: `${pre}accountAnalysis_wx`,
      component: _import('spread/accountAnalysis/wx'),
      meta: {
        title: '微信'
      }
    },
    {
      path: 'topicAnalysis',
      name: `${pre}topicAnalysis`,
      component: _import('spread/topicAnalysis'),
      meta: {
        title: '选题分析汇总'
      }
    },
    {
      path: 'scoreSetting',
      name: `${pre}scoreSetting`,
      component: _import('spread/scoreSetting'),
      meta: {
        title: '绩效评分设置'
      }
    },
    {
      path: 'accountPicture',
      name: `${pre}accountPicture`,
      component: _import('spread/accountPicture/index'),
      meta: {
        title: '账号画像'
      }
    }
  ])('spread/')
}
